
import people1 from '../../assest/ahbaab/badge.png'
import people2 from '../../assest/ahbaab/experience.png'
import people3 from '../../assest/ahbaab/package-customization.png'
import people4 from '../../assest/ahbaab/project-management.png'



const ValuesData = [
    {
        id: 1,
        heading: "Quality",
        textdetail: "Delivering products that meet the highest industry standards, ensuring safety, reliability, and performance every time.",
        imgSrc: people1,
    },

    {
        id: 2,
        heading: "Customer Focus",
        textdetail: "Building strong partnerships through dependable service, timely delivery, and tailored solutions for every client’s needs.",
        imgSrc: people2,
    },
    {
        id: 3,
        heading: "Integrity",
        textdetail: "Operating with honesty, transparency, and full compliance, earning the trust of our partners and customers alike.",
        imgSrc: people3,
    },
    {
        id: 4,
        heading: "Innovation",
        textdetail: "Constantly improving and adapting to drive efficiency, value, and excellence across all our offerings.",
        imgSrc: people4,
    }
];
export default ValuesData